import { HUB_PATHS } from './cardMeanings';
import { chartHref } from './chartLanguage';
import { NAV_COPY } from './navCopy';
import { SITE_LANGUAGE_CODES } from './siteLanguages';
import { LEARN_LANG_CODES, LEARN_TAROT_ENABLED } from '../pages/LearnTarot/learnData';
import { cardOfTheDayPath } from '../pages/Landing/homeLinks';

const LEARN = new Set(LEARN_LANG_CODES);

const POPULAR = ['cardOfTheDay', 'yesNo', 'love', 'threeCard', 'birthChart', 'aiPsychic'];
const READINGS = ['allReadings', 'interpreter', 'celtic', 'career', 'dailyReading', 'newLove', 'mindBody', 'sixCard'];
const LEARN_ITEMS = ['learnGuides', 'meanings', 'history'];
const CHARTS = ['birthChart', 'dailyAstro', 'chartCompat'];
const SIGNS = ['bigThree', 'rising', 'moonSign', 'venus', 'zodiac'];
const MORE = ['moonPhase', 'lifePath', 'birthCard'];

export function navLanguage(pathname) {
  const parts = String(pathname || '').split('/').filter(Boolean);
  if (parts[0] === 'ai-psychic') {
    return SITE_LANGUAGE_CODES.includes(parts[1]) ? parts[1] : 'en';
  }
  if (parts[0] === 'learn-tarot') {
    return LEARN.has(parts[1]) ? parts[1] : 'en';
  }
  return SITE_LANGUAGE_CODES.includes(parts[0]) ? parts[0] : 'en';
}

export function askHomePath(lang) {
  return !lang || lang === 'en' ? '/' : `/${lang}/`;
}

function learnPath(lang, slug) {
  const base = lang !== 'en' && LEARN.has(lang) ? `/learn-tarot/${lang}/` : '/learn-tarot/';
  return slug ? `${base}${slug}/` : base;
}

function hrefFor(id, lang) {
  switch (id) {
    case 'cardOfTheDay': return cardOfTheDayPath(lang);
    case 'yesNo': return '/yes-or-no-tarot/';
    case 'love': return '/love-tarot-reading/';
    case 'threeCard': return '/three-card-tarot/';
    case 'birthChart': return chartHref('/birth-chart/', lang);
    case 'aiPsychic': return lang && lang !== 'en' ? `/ai-psychic/${lang}/` : '/ai-psychic/';
    case 'allReadings': return '/free-tarot/';
    case 'interpreter': return chartHref('/tarot-card-interpreter/', lang);
    case 'celtic': return '/celtic-cross-tarot/';
    case 'career': return '/career-tarot-reading/';
    case 'dailyReading': return '/daily-tarot-reading/';
    case 'newLove': return '/new-love-tarot-reading/';
    case 'mindBody': return '/mind-body-spirit-tarot/';
    case 'sixCard': return '/six-card-tarot-spread/';
    case 'learnGuides': return learnPath(lang);
    case 'meanings': return HUB_PATHS[lang] || HUB_PATHS.en;
    case 'history': return learnPath(lang, 'history-of-tarot-cards');
    case 'dailyAstro': return chartHref('/personalized-daily-horoscope/', lang);
    case 'chartCompat': return chartHref('/birth-chart-compatibility/', lang);
    case 'bigThree': return '/big-three-calculator/';
    case 'rising': return '/rising-sign-calculator/';
    case 'moonSign': return '/moon-sign-calculator/';
    case 'venus': return '/venus-sign-calculator/';
    case 'zodiac': return '/zodiac-compatibility/';
    case 'moonPhase': return '/moon-phase-today/';
    case 'lifePath': return '/life-path-number-calculator/';
    case 'birthCard': return '/tarot-birth-card-calculator/';
    default: return '/';
  }
}

function copyFor(lang) {
  const english = NAV_COPY.en;
  const local = NAV_COPY[lang];
  if (!local) return english;
  return {
    ...english,
    ...local,
    items: { ...english.items, ...(local.items || {}) },
  };
}

function links(ids, copy, lang) {
  return ids.map((id) => ({
    id,
    to: hrefFor(id, lang),
    label: copy.items[id],
  }));
}

export function buildNav(lang) {
  const copy = copyFor(lang || 'en');
  const learn = LEARN_TAROT_ENABLED ? [{ id: 'learn', label: copy.learn, links: links(LEARN_ITEMS, copy, lang) }] : [];
  return {
    copy,
    lang: lang || 'en',
    dir: lang === 'ar' ? 'rtl' : 'ltr',
    home: askHomePath(lang),
    popular: links(POPULAR, copy, lang),
    tarot: [
      { id: 'readings', label: copy.readings, links: links(READINGS, copy, lang) },
      ...learn,
    ],
    astrology: [
      { id: 'charts', label: copy.charts, links: links(CHARTS, copy, lang) },
      { id: 'signs', label: copy.signs, links: links(SIGNS, copy, lang) },
      { id: 'more', label: copy.more, links: links(MORE, copy, lang) },
    ],
  };
}
